export { parse, format, resolve, resolveObject, Url } from 'native-url';

// patch native-url https://github.com/GoogleChromeLabs/native-url/pull/18
export const URL = global?.URL ?? window?.URL ?? Url;
